import { render, staticRenderFns } from "./W-Button.vue?vue&type=template&id=e11cc572&"
import script from "./W-Button.vue?vue&type=script&lang=js&"
export * from "./W-Button.vue?vue&type=script&lang=js&"
import style0 from "./W-Button.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpinnerGears from 'quasar/src/components/spinner/QSpinnerGears.js';
import qInstall from "../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QBtn,QSpinnerGears});
